import Enumerable from "linq";
import { Department } from "../department";
import { DepartmentRelatedHisInformation } from "./DepartmentRelatedHisInformation";
import { HisInformation } from "./HisInformation";
import { HisInformationItem } from "./HisInformationItem";

class ProcessingHisInformationItem {
  constructor(public item: HisInformationItem) {
  }
  isMerged: boolean;
}

export class DepartmentRelatedHisInformationMerger {
  public mergeDepartmentRelatedHisInformation(hisInfo: HisInformation, department: Department): void {
    if (!hisInfo) { return; }

    const relatedInfo = this.getDepartmentRelatedHisInformation(hisInfo.departmentRelatedInformations, department);
    if (!relatedInfo) { return; }
    
    const processingHisInformationItems = relatedInfo.items.map(i => new ProcessingHisInformationItem(i));
    for (let index = 0; index < hisInfo.items.length; ++index) {
      const hisInfoItem = hisInfo.items[index];
      if (!hisInfoItem) { continue; }

      const found = Enumerable.from(processingHisInformationItems).firstOrDefault(i => i.item.name === hisInfoItem.name);
      if (!found) { continue; }

      hisInfo.items.splice(index, 1, found.item);
      found.isMerged = true;
    }
    for (const processingHisInformationItem of processingHisInformationItems) {
      if (processingHisInformationItem.isMerged) { continue; }
      hisInfo.items.push(processingHisInformationItem.item);
    }
  }

  private getDepartmentRelatedHisInformation(infos: DepartmentRelatedHisInformation[], department: Department): DepartmentRelatedHisInformation {
    if (!infos) { return null; }
    if (department) {
      const found = Enumerable.from(infos).firstOrDefault(i => i.departmentCodes.indexOf(department.id) >= 0);
      if (found) { return found; }
    }
    return Enumerable.from(infos).firstOrDefault(i => i.isDefault);
}
}
